
import SearchIcon from "@mui/icons-material/Search";
import { Input, Paper, styled } from "@mui/material";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const PREFIX = "Header1";
const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  input: `${PREFIX}-input`,
};

const RootPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
      borderRadius: "4px",
      alignItems: "center",
      padding: theme.spacing(1),
      display: "flex",
      flexBasis: 420
    },
    [`& .${classes.icon}`]: {
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary
    },
    [`& .${classes.input}`]: {
      flexGrow: 1,
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "-0.05px"
    }
  })
);
//eslint-disable-next-line
interface PropTypes {
  className?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  style: React.CSSProperties;
}

const SearchInput = (props: PropTypes) => {
  const { className, onChange, style, ...rest } = props;
  return (
    <RootPaper {...rest} className={clsx(classes.root, className)} style={style}>
      <SearchIcon className={classes.icon} />
      <Input {...rest} className={classes.input} disableUnderline onChange={onChange} />
    </RootPaper>
  );
};


export default SearchInput;
